<style>
    @media (max-width: 960px) {
        div.p-tooltip-top > div.p-tooltip-text {
            margin-top: -10px !important;
            margin-bottom: -10px !important;
        }
        div.p-tooltip-arrow {
            display: none;
        }
    }
</style>
<div class="row">
    <div class="col-12">
        <section class="br-card bg-gray-5" aria-label="Informações funcionais">
            <div class="card-content">
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-nome">Nome</label>
                        <p id="cabecalho-funcional-nome">
                            {{ exercicioSelecionado.nome }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-cpf">CPF</label>
                        <p id="cabecalho-funcional-cpf">{{ exercicioSelecionado.cpf }}</p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-chefia">Chefia Imediata Atual/UORG</label>
                        <p id="cabecalho-funcional-chefia">
                            {{ exercicioSelecionado.chefiaImediata }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-vinculo">Matrícula/Cargo em Exercício</label>
                        <p id="cabecalho-funcional-vinculo">
                            {{ exercicioSelecionado.vinculoEmExercicio }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-orgao">Órgão em Exercício</label>
                        <p id="cabecalho-funcional-orgao">
                            {{ exercicioSelecionado.orgaoEmExercicio }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-regime">Regime Jurídico</label>
                        <p id="cabecalho-funcional-regime">
                            {{ exercicioSelecionado.regime }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-exercicio">Exercício</label>
                        <p id="cabecalho-funcional-exercicio">
                            {{ exercicioSelecionado.anoExercicio }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-aquisitivo">Período Aquisitivo</label>
                        <p id="cabecalho-funcional-aquisitivo">
                            {{ exercicioSelecionado.dataInicioPeriodoAquisitivo | dataFormatada }}
                            a
                            {{ exercicioSelecionado.dataFimPeriodoAquisitivo | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-quantidade">Quantidade de Dias</label>
                        <p id="cabecalho-funcional-quantidade">
                            {{ quantidadeDiasExibida }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-situacao">Situação do Exercício</label>
                        <p id="cabecalho-funcional-situacao">
                            {{ exercicioSelecionado.situacaoExercicio }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-programacao">Período de Programação</label>
                        <p id="cabecalho-funcional-programacao">
                            {{ exercicioSelecionado.dataInicioPeriodoProgramacao | dataFormatada }}
                            a
                            {{ exercicioSelecionado.dataFimPeriodoProgramacao | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2" *ngIf="exibirPeriodoProgramacaoDisponivel && !exercicioSelecionado.raioX && exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel && exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel">
                        <label for="cabecalho-funcional-programacao-disponivel">Período de programação disponível</label>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" pTooltip="Período disponível para marcação de férias considerando os exercícios anteriores." tooltipStyleClass="tooltip-cabecalho-funcional"></i>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" pTooltip="Período disponível para marcação de férias considerando os exercícios anteriores." tooltipStyleClass="tooltip-cabecalho-funcional" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        <p id="cabecalho-funcional-programacao-disponivel">{{ exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel | dataFormatada }} a {{ exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel | dataFormatada }}</p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2" *ngIf="exibirTipoPeriodoAquisitivo && !exibirPeriodoProgramacaoDisponivel">
                        <label for="cabecalho-funcional-tipo-aquisitivo">Tipo de Período Aquisitivo</label>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" [escape]="false" pTooltip="Indica como o período que gera o direito às férias é calculado:<br><br><strong>Período aquisitivo</strong>: data de ingresso mais 12 meses.<br><br><strong>Ano civil</strong>:  conforme o ano-calendário." tooltipStyleClass="tooltip-cabecalho-funcional"></i>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" [escape]="false" pTooltip="Indica como o período que gera o direito às férias é calculado:<br><br><strong>Período aquisitivo</strong>: data de ingresso mais 12 meses.<br><br><strong>Ano civil</strong>:  conforme o ano-calendário." tooltipStyleClass="tooltip-cabecalho-funcional" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        <p id="cabecalho-funcional-tipo-aquisitivo">{{ descricaoTipoPeriodoAquisitivo }}</p>
                    </div>
                </div>
                <div class="row" *ngIf="exibirTipoPeriodoAquisitivo && exibirPeriodoProgramacaoDisponivel">
                    <div class="col-12 col-lg-4 mt-2">
                        <label for="cabecalho-funcional-tipo-aquisitivo">Tipo de Período Aquisitivo</label>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" [escape]="false" pTooltip="Indica como o período que gera o direito às férias é calculado:<br><br><strong>Período aquisitivo</strong>: data de ingresso mais 12 meses.<br><br><strong>Ano civil</strong>:  conforme o ano-calendário." tooltipStyleClass="tooltip-cabecalho-funcional"></i>
                        <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" [escape]="false" pTooltip="Indica como o período que gera o direito às férias é calculado:<br><br><strong>Período aquisitivo</strong>: data de ingresso mais 12 meses.<br><br><strong>Ano civil</strong>:  conforme o ano-calendário." tooltipStyleClass="tooltip-cabecalho-funcional" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        <p id="cabecalho-funcional-tipo-aquisitivo">
                            {{ descricaoTipoPeriodoAquisitivo }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
